import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import PropTypes from 'prop-types';
import { loadLanguagePack } from '@americanexpress/one-app-ducks';
import { queryModule } from 'iguazu-holocron';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectAsync } from 'iguazu';
import SharedScript from '@americanexpress/shared-scripts';
// import { Adobe } from '@americanexpress/shared-scripts';
import Helmet from 'react-helmet';
// import DataManager from '@americanexpress/data-manager';
// import { AmexDDLRegister, getAmexDataManagerConfig } from '@americanexpress/data-manager-utils';
import childRoutes from '../childRoutes';
import CommonError from './CommonError';
import getOneCmsUrl from '../services/OneCmsUrl';

/* istanbul ignore next */
const getLocale = () => {
  const url = window.location.href;
  const parsedUrl = new URL(url);
  const path = parsedUrl.pathname;
  const pathSegments = path.split('/');
  pathSegments.shift();
  return pathSegments[0];
};
/* istanbul ignore next */
export const AxpMapsTravelersChequesRoot = ({
  GlobalHeader, GlobalFooter, children, locale, router,
}) => {
  /* istanbul ignore next */
  const urlLocale = getLocale();
  const [errorFlag, setErrorFlag] = useState(false);

  /* istanbul ignore next */
  const navigateToCommonErr = () => {
    router.push({ pathname: `/${urlLocale}/travel/travelers-cheques/locator/error` });
  };
  /* istanbul ignore next */
  useEffect(() => {
    const location = `${window.location.protocol}//${window.location.host}`;
    const oneCmsUrl = getOneCmsUrl(location);
    fetch(oneCmsUrl).then((resp) => resp.json().then((rsp) => {
      console.log('response from one cms supported locale list ==>', rsp);
      if (resp.status === 200) {
        if (rsp?.supportedUrlLocaleList?.includes(urlLocale)) {
          console.log('present', urlLocale);
          setErrorFlag(false);
        } else {
          console.log('absent');
          setErrorFlag(true);
          navigateToCommonErr();
        }
      } else {
        setErrorFlag(true);
      }
    }));
  }, [urlLocale]);

  /* istanbul ignore next */
  if (errorFlag === true) {
    return (
      <div>
        <GlobalHeader />
        <center>
          <CommonError />
        </center>
        <GlobalFooter />
      </div>
    );
  }
  /* istanbul ignore next */
  return (
    <IntlProvider locale={locale}>
      <Helmet
        {...{
          htmlAttributes: {
            lang: 'en-US',
          },
          meta: [
            { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
            { charset: 'utf-8' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
            { name: 'application-name', content: 'American Express' },
            { name: 'robots', content: 'noindex, nofollow' },
          ],
        }}
      >
        <link
          rel="stylesheet"
          href=" https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.11.2/stylesheets/dls-core.min.css"
        />
        <script
          type="text/javascript"
          src="https://www.aexp-static.com/cdaas/one/statics/@americanexpress/dls/6.25.6/package/dist/6.25.6/scripts/dls.min.js"
        />
      </Helmet>
      <SharedScript
        name="user-consent-management"
        windowCheck="UserConsentManagementConsentChecking"
        version="^1.0.0"
      />
      {/*  <Adobe
        version="^1.2.0"
      />
      <DataManager {...getAmexDataManagerConfig({
        initialDDL: {
          ddl: {
            view: {
              language: window.location.pathname.split('/')[1].split('-')[0],
              country: window.location.pathname.split('/')[1].split('-')[1]?.toUpperCase(),
              locale: `${window.location.pathname.split('/')[1].split('-')[0]}-${window.location.pathname.split('/')[1].split('-')[1]?.toUpperCase()}`,
            },
          },
        },
      })}
      >
        <AmexDDLRegister />
      </DataManager> */}

      <div>
        <div>
          <GlobalHeader />
        </div>
        { errorFlag === false && (
        <div>
          {children}
        </div>
        )}
        <div>
          <GlobalFooter />
        </div>
      </div>
    </IntlProvider>
  );
};
/* istanbul ignore next */
AxpMapsTravelersChequesRoot.childRoutes = childRoutes;

/* istanbul ignore next */
AxpMapsTravelersChequesRoot.propTypes = {
  children: PropTypes.node.isRequired,
  GlobalHeader: PropTypes.func.isRequired,
  GlobalFooter: PropTypes.func.isRequired,
};

/* istanbul ignore next */
if (!global.BROWSER) {
  // eslint-disable-next-line global-require
  AxpMapsTravelersChequesRoot.appConfig = require('../appConfig').default;
}

/* istanbul ignore next */
export const loadModuleData = async ({
  store: { dispatch },
}) => {
  await dispatch(loadLanguagePack('axp-maps-travelers-cheques-root', { fallbackLocale: 'en-US' }));
};

/* istanbul ignore next */
const loadDataAsProps = ({ store: { dispatch } }) => ({
  GlobalHeader: () => dispatch(queryModule('axp-global-header')),
  GlobalFooter: () => dispatch(queryModule('axp-footer')),
});

/* istanbul ignore next */
AxpMapsTravelersChequesRoot.holocron = {
  name: 'axp-maps-travelers-cheques-root',
  loadModuleData,
};

/* istanbul ignore next */
const hocChain = compose(
  oneAppModuleWrapper('axp-maps-travelers-cheques-root'),
  connect(),
  connectAsync({ loadDataAsProps })
);

export default hocChain(AxpMapsTravelersChequesRoot);
